// extracted by mini-css-extract-plugin
export default {"container":"yMz2sx","title":"KamUOK","eyebrowText":"TPenFu","subtitle":"r6ehDi"};